module.exports = __webpack_public_path__ + "static/media/emptyUser.7ed2775b.svg";